import { CSSProperties } from 'react'
import './styles.scss'
import { SquircleAdapter } from '../SquircleAdapter'
import { BiLoaderAlt } from 'react-icons/bi'

interface IButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  onClick: () => void
  variant?: 'primary'
  text?: string | null
  rightRender?: JSX.Element
  leftRender?: JSX.Element
  style?: CSSProperties
  disabled?: boolean
  loading?: boolean
  containerClassName?: string
  cornerRadius?: number
}

export function Button({
  variant = 'primary',
  text,
  rightRender,
  leftRender,
  onClick,
  style,
  disabled,
  loading,
  className,
  containerClassName,
  cornerRadius = 12,
  'aria-disabled': ariaDisabled,
  ...rest
}: IButtonProps) {
  // aria-disabled sinaliza indisponibilidade sem tirar o botão do teclado,
  // para que o clique ainda possa explicar o que falta.
  const unavailable =
    disabled || ariaDisabled === true || ariaDisabled === 'true'

  return (
    <button
      className={`button-container ${containerClassName}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-disabled={ariaDisabled}
      style={style}
      {...rest}
    >
      <SquircleAdapter
        cornerRadius={cornerRadius}
        className={`button ${variant} ${className}`.trim()}
        aria-disabled={unavailable}
      >
        {!loading && leftRender}
        {!!text && <p>{text}</p>}
        {loading && <BiLoaderAlt className="button__loading" fontSize={24} />}
        {!loading && rightRender}
      </SquircleAdapter>
    </button>
  )
}
